export default __webpack_public_path__ + "static/media/ray8.bc86a90c.webp";